import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";

const LegacyPayPalButton = ({ handleButtonClick }) => (
    <Button onClick={handleButtonClick} btnStyle="paypal">
        Donate with
        <img
            src="/resources/core/images/logo-paypal-horizontal.png"
            alt="PayPal"
            title="PayPal"
            className="paypal__logo -margin-left--10"
        />
    </Button>
);

LegacyPayPalButton.propTypes = {
    handleButtonClick: PropTypes.func.isRequired,
};

export default LegacyPayPalButton;
